import { useEffect, type ReactNode } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { applyTheme } from '@/utils/theme';

/**
 * Applique le thème CTO-FRONT-002 (classe .t-XXX sur <body>) selon la filiale
 * connectée. Rétrocompatibilité : continue à set --color-primary/secondary/accent
 * pour les composants Jours 3-6 qui ne sont pas encore refondus.
 */
export const FilialeTheme = ({ children }: { children: ReactNode }) => {
  const filiale = useAuthStore((s) => s.filiale);

  useEffect(() => {
    // Toujours appliquer un thème (Leadbeton par défaut) — même hors session
    applyTheme(filiale?.filialeKey);

    if (filiale) {
      // Rétrocompat : les pages existantes lisent ces vars custom
      const root = document.documentElement;
      root.style.setProperty('--color-primary',   filiale.colorPrimary);
      root.style.setProperty('--color-secondary', filiale.colorSecondary);
      root.style.setProperty('--color-accent',    filiale.colorAccent);
    }
  }, [filiale]);

  return <>{children}</>;
};
